module.exports = __webpack_public_path__ + "img/荣誉证书09_科创基金会2019全球创业周雏鹰奖.fd3b0825.png";